import * as z from 'zod';

const emailSchema = z.email();

export function isValidEmail(value: string): boolean {
    return emailSchema.safeParse(value).success;
}
